import {
    REQUEST_ARTICLE,
    RECEIVE_ARTICLE,
    REQUEST_PAGED_ARTICLES,
    RECEIVE_PAGED_ARTICLES
} from "./article.actions";

const requestArticle = () => {
    return {
        type: REQUEST_ARTICLE
    };
};

const receiveArticle = singleArticle => {
    return {
        type: RECEIVE_ARTICLE,
        singleArticle
    };
};

const requestPagedArticles = () => {
    return {
        type: REQUEST_PAGED_ARTICLES
    };
};

const receivePagedArticles = articles => {
    return {
        type: RECEIVE_PAGED_ARTICLES,
        articles
    };
};

export {
    requestArticle,
    receiveArticle,
    requestPagedArticles,
    receivePagedArticles
};



// WEBPACK FOOTER //
// ./src/actions/article/article.creators.js